import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "borehub_selected_tbm";
const TbmCtx = createContext(null);

export function TbmProvider({ children }) {
  const { user } = useAuth();
  const [tbms, setTbms] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const list = await api.get("/tbms");
      setTbms(list);
      const savedId = localStorage.getItem(KEY);
      setSelected((prev) => list.find((t) => t.id === (prev?.id || savedId)) || list[0] || null);
    } catch {
      /* keep prior state */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (user) reload();
    else {
      setTbms([]);
      setSelected(null);
    }
  }, [user, reload]);

  const selectTbm = useCallback(
    (id) => {
      const t = tbms.find((x) => x.id === id) || null;
      setSelected(t);
      if (t) localStorage.setItem(KEY, t.id);
    },
    [tbms],
  );

  return (
    <TbmCtx.Provider value={{ tbms, selected, selectTbm, reload, loading }}>{children}</TbmCtx.Provider>
  );
}

export const useTbm = () => useContext(TbmCtx);
